import { useState } from "react";
import { Link2, Mail, Check, Copy } from "lucide-react";
import { toast } from "sonner";

export const ShareLink = ({ reference, plz }) => {
  const [copied, setCopied] = useState(false);
  if (!reference || !plz) return null;

  const url = `${window.location.origin}/s/${encodeURIComponent(reference)}-${encodeURIComponent(plz)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link in Zwischenablage kopiert");
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      toast.error("Konnte Link nicht kopieren");
    }
  };

  const mailHref = `mailto:?subject=${encodeURIComponent(
    `Sendungsverfolgung · ${reference}`,
  )}&body=${encodeURIComponent(
    `Hier können Sie den Status Ihrer Sendung ${reference} live verfolgen:\n\n${url}\n\nMit freundlichen Grüßen\nMail Boxes Etc`,
  )}`;

  return (
    <div
      className="overflow-hidden rounded-2xl bg-white ring-1 ring-slate-200"
      data-testid="share-link-box"
    >
      <div className="border-b border-slate-100 bg-slate-50 px-5 py-3">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-slate-600">
          <Link2 size={14} className="text-indigo-600" />
          Direkt-Link zum Teilen
        </div>
      </div>
      <div className="flex items-stretch">
        <div
          className="flex-1 truncate px-5 py-4 text-sm text-slate-700"
          title={url}
          data-testid="share-link-url"
        >
          {url}
        </div>
        <button
          onClick={copy}
          className="inline-flex shrink-0 items-center gap-1.5 border-l border-slate-100 px-4 text-xs font-semibold text-slate-700 transition-colors hover:bg-slate-50"
          title="Link kopieren"
          data-testid="share-link-copy"
        >
          {copied ? (
            <Check size={14} className="text-emerald-600" />
          ) : (
            <Copy size={14} />
          )}
          <span className="hidden md:inline">
            {copied ? "Kopiert" : "Kopieren"}
          </span>
        </button>
        <a
          href={mailHref}
          className="inline-flex shrink-0 items-center gap-1.5 bg-indigo-600 px-4 text-xs font-semibold text-white transition-colors hover:bg-indigo-700"
          title="Per E-Mail teilen"
          data-testid="share-link-mail"
        >
          <Mail size={14} />
          <span className="hidden md:inline">E-Mail</span>
        </a>
      </div>
    </div>
  );
};
